import { useRouter } from 'next/router';
import { useEffect } from 'react';

// On initial load if there are any url fragments they won't be scrolled into view
// since the application hasn't yet loaded. This navigates to a url fragment after
// the page has loaded
const useURLFragmentLink = () => {
  const { asPath, isReady } = useRouter();

  useEffect(() => {
    const [_, hash] = asPath.split('#');
    if (hash && isReady) {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [asPath, isReady]);
};

export default useURLFragmentLink;
